<template>
  <PageLayout>
    <div class="main-content_wrap">
      <div class="main-content">
        <div class="container">
          <!-- Not on mobile: the checklist lives in the mobile Library.
               The router guard redirects every mobile navigation to this
               route; the v-if covers the desktop→mobile resize case while
               parked here. -->
          <GetStartedChecklist v-if="!isMobile" />
        </div>
      </div>
    </div>
    <div class="popup-container"></div>
  </PageLayout>
</template>

<script>
import { analytics } from "@/services/analytics.service";

import PageLayout from "@/components/PageLayout.vue";
import GetStartedChecklist from "@/components/onboarding/GetStartedChecklist.vue";
import { useIsMobile } from "@/composables/useIsMobile";

export default {
  name: "HomeView",
  components: {
    PageLayout,
    GetStartedChecklist,
  },
  setup() {
    const { isMobile } = useIsMobile();
    return { isMobile };
  },
  created() {
    // Add the 'login-page' class to the body and remove the 'nav-active' class
    document.body.classList.add("nav-active");
    document.body.classList.remove("login-page");
  },
  mounted() {
    // The mobile shell has no Home tab — the router guard redirects every
    // mobile navigation to Library before this view can mount.
    analytics.homeViewed();
  },
};
</script>
